import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';

function GoogleSheetsNode({ data, selected }) {
  return (
    <div className={`rounded-xl border-2 bg-white dark:bg-gray-900 shadow-sm min-w-[180px] transition-shadow ${
      selected ? 'border-green-500 shadow-green-100 dark:shadow-green-900/20' : 'border-gray-200 dark:border-gray-700'
    }`}>
      <Handle type="target" position={Position.Top} className="!bg-green-500 !w-3 !h-3 !border-2 !border-white dark:!border-gray-900" />
      <div className="flex items-center gap-2 px-4 py-2.5 bg-green-50 dark:bg-green-900/20 rounded-t-[10px] border-b border-gray-200 dark:border-gray-700">
        <div className="w-2.5 h-2.5 rounded-full bg-[#34A853]" />
        <span className="text-xs font-semibold text-green-700 dark:text-green-300">Google Sheets</span>
      </div>
      <div className="px-4 py-3 text-xs text-gray-500 dark:text-gray-400">
        {data.config?.spreadsheetId ? `Sheet: ...${data.config.spreadsheetId.slice(-8)}` : 'Click to configure'}
      </div>
      <Handle type="source" position={Position.Bottom} className="!bg-green-500 !w-3 !h-3 !border-2 !border-white dark:!border-gray-900" />
    </div>
  );
}

export default memo(GoogleSheetsNode);
